<template>
  <v-form ref="mainForm" v-model="valid">
    <CatalogueLive code="ordre_ouinon" v-model="sas.sasReconnaissanceArmFranceQuebec.ordresProfessionnels" :live="liveSasReconnaissanceArm(9017)" />
    <data-iterator
      :list="sas.sasMembreAutreOrdre"
      add-new-text="Ajouter un ordre professionnel"
      :live="{ endpoint: 'sas-membre-autre-ordre', sasId: sas.id }"
      :icon="$getIcon('job')"
      :valids="valids"
      ref="dataIterator"
      :opq-if="estOui(sas.sasReconnaissanceArmFranceQuebec.ordresProfessionnels)"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.nom }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="ordre_nom" v-model="item.nom" :live="liveSasMembreAutreOrdre(6804, item)" />
        <TextFieldLive code="ordre_numero" v-model="item.nPermis" :live="liveSasMembreAutreOrdre(6805, item)" />
        <DatePickerLive
          code="ordre_debut"
          v-model="item.dateDeDebut"
          :live="liveSasMembreAutreOrdre(6807, item)"
          :maxValue="convertDateToString(new Date())"
        />
        <DatePickerLive
          code="ordre_fin"
          v-model="item.dateDeFin"
          :live="liveSasMembreAutreOrdre(6808, item)"
          :maxValue="convertDateToString(new Date())"
        />
        <FileInput code="ordre_preuve" :file="item.preuve" :live="liveSasMembreAutreOrdre(6806, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers],
  props: {
    sas: { type: Object }
  },
  computed: {
    sasReconnaissanceArm() {
      return this.sas.sasReconnaissanceArmFranceQuebec
    }
  },
  methods: {
    liveSasMembreAutreOrdre(cle, item) {
      return { endpoint: "sas-membre-autre-ordre", cle: cle, fileId: item.id }
    },
    liveSasReconnaissanceArm(cle) {
      return { endpoint: "sas-reconnaissance-arm-france-quebec", cle: cle, fileId: this.sasReconnaissanceArm.id }
    }
  }
}
</script>

<style></style>
